<template>
  <div class="animated fadeIn">
    <div class="card card-green">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-12  table-responsive">
            <table class="table table-bordered table-striped table-hover table-sm table-logoped">
              <thead>
                <tr>
                  <th>
                    {{ $t('NAME') }}
                  </th>
                  <th>
                    {{ $t('ISNOTEREAD') }}
                  </th>
                  <th>{{ $t('ACTION') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="item.noteId" aria-rowindex="1" class=" table-ellipsis" v-for="item in response.root">
                  <td>{{ item.note }}</td>
                  <td>{{ (item.isRead) ? $t('YES') : $t('NO') }}</td>
                  <td>
                    <button type="button" class="btn button-edit mr-2" @click="showNoteModal(item)">{{ $t('EDIT') }}</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <nav>
              <pagination v-bind:totalCount="response.totalCount" v-model="pagination" v-on:reload="getData">
              </pagination>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="formnotemodal" :title="$t('NOTEFORM')" ok-title="submit" hide-footer no-close-on-backdrop>
      <div class="d-block">
        <noteform v-bind:formData="noteFormData" v-bind:formError="formError"></noteform>
      </div>
      <div class="text-right">
        <b-btn class="mt-3" variant="btn button-cancel mr-lg" @click="hideNoteModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="mt-3 btn button-save" @click="submitNoteData(noteFormData)">{{$t('SAVE')}}</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Api from '@/api/notes/Note';
import NoteForm from './NoteForm.vue';

export default
  {
    name: 'Note',
    components:
    {
      noteform: NoteForm,
    },
    data() {
      return {
        response:
          {},
          noteFormData: {
                note: '',
            },
            formError:
        {},
        pagination:
        {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
        },
      };
    },
    created() {
      const me = this;
      me.getData();
    },
    methods:
    {
      async getData() {
        const me = this;
        try {
          const data = await Api.selectRow(me.getParams);
          if (data.error && data.error === true) {
            me.$notify.notice(data);
            me.loading = false;
            return;
          }

          me.response = data;
        }
        catch (e) {
          me.$notify.notice(e);
        }
      },
      showNoteModal(item)
      {
        const me = this;
          if (typeof item !== 'undefined')
          {
              me.noteFormData = item;
          }
          me.$refs.formnotemodal.show();
      },
      async submitNoteData(item)
      {
          const me = this;
          try
          {
              if (typeof item.noteId !== 'undefined')
              {
                  item.id = item.noteId;
                  delete (item.noteId);
              }

              const data = await Api.submitData(item);
              if (data.error)
              {
                  me.formError = data;
                  throw (data);
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideNoteModal();
                  await me.getNotes();
              }
          }
          catch (e)
          {
              console.log(e);
              me.$notify.notice(e);
          }
      },
      hideNoteModal()
      {
          const me = this;
          this.$refs.formnotemodal.hide();

          me.noteFormData = {
              note: '',
          };
      },
    },
    watch:
    {
      'pagination.limit'() {
        const me = this;
        me.getData();
      },
      'pagination.currentPage'() {
        const me = this;
        me.getData();
      },
      'pagination.query'() {
        const me = this;

        if (me.pagination.searchTimeout !== false) {
          clearTimeout(me.pagination.searchTimeout);
        }

        me.pagination.searchTimeout = setTimeout(() => {
          me.getData();
          me.pagination.searchTimeout = false;
        }, 300);
      },
    },
    computed:
    {
      getParams() {
        const me = this;
        const data = {
          ...me.pagination,
        };
        data.start = (data.currentPage - 1) * data.limit;
        return data;
      },
    },
  };
</script>
